/**
 * KRA Photo Journal – usePhotographers Hook
 * Fetches and caches the photographer list for the filter UI.
 */

import { useState, useEffect } from "react";
import { fetchPhotographers } from "../lib/api.js";

export function usePhotographers() {
  const [photographers, setPhotographers] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetchPhotographers()
      .then((list) => {
        if (!cancelled) setPhotographers(list);
      })
      .catch(console.error)
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  return { photographers, isLoading };
}
